import {axios as http} from "@/plugins/http"

export default class ApiBase {
    static image(payload) {
        return http.post('/api/v1/catalog/image', payload)
    }

    static categories() {
        return http.get('/api/v1/catalog/list')
    }

    static update(payload) {
        return http.post('/api/v1/catalog/update', payload)
    }

    static create(payload) {
        return http.post('/api/v1/catalog/create', payload)
    }

    static delete(ids) {
        return http.delete('/api/v1/catalog/delete', {
            data: {
                ids,
            },
        });
    }

    static move(items) {
        return http.post('/api/v1/catalog/replace', {
            items,
        });
    }
}
